import { atomWithStorage } from 'jotai/utils'
import type { ShipmentPreparationPallet } from 'types/shipment/model'

export const transferPalletsAtom = atomWithStorage<ShipmentPreparationPallet[]>(
  'transferPalletsAtom',
  []
)
